import SkateHolderLength from "./SkateHolderLength";
export default SkateHolderLength;
